import { Component } from '@angular/core';
import { BaseConfirmationDialogComponent } from '../base-confirmation-dialog.component';

@Component({
  selector: 'boi-session-about-to-expire-dialog',
  templateUrl: './session-about-to-expire-dialog.component.html',
  styleUrls: ['./session-about-to-expire-dialog.component.scss']
})
export class SessionAboutToExpireDialogComponent extends BaseConfirmationDialogComponent<void> {
  constructor() {
    super();
  }
}
